<script setup lang="ts">
const props = withDefaults(defineProps<{
  rating?: number | string
  styleStarSize?: number | string
  styleEmptyStarColor?: string
  styleFullStarColor?: string
  maxRating?: string
  position?: string
}>(), {
  rating: 88,
  styleStarSize: 16,
  styleEmptyStarColor: '#CACACA',
  styleFullStarColor: '#0ACC58',
  position: 'center',
})

const ratingRecalculated = +props.rating / 20
const stars: any = []
const emptyStar = 0
const fullStar = 1
const totalStars = 5

function calcStarPoints() {
  const center = +props.styleStarSize / 2
  const innerCircleArms = 5
  const innerRadius = +props.styleStarSize / innerCircleArms
  const innerOuterRadiusRatio = 2.5
  const outerRadius = innerRadius * innerOuterRadiusRatio
  const angle = Math.PI / innerCircleArms
  const angleOffsetToCenterStar = 60
  const totalArms = innerCircleArms * 2
  let points = ''

  for (let i = 0; i < totalArms; i++) {
    const isEvenIndex = i % 2 === 0
    const r = isEvenIndex ? outerRadius : innerRadius
    const currX = center + Math.cos(i * angle + angleOffsetToCenterStar) * r
    const currY = center + Math.sin(i * angle + angleOffsetToCenterStar) * r
    points += `${currX},${currY} `
  }
  return points
}
const getStarPoints = calcStarPoints()
function calcStarFullness(starData: any) {
  return `${starData.raw * 100}%`
}
function setStars() {
  let fullStarsCounter = Math.floor(ratingRecalculated)
  for (const i in stars) {
    if (fullStarsCounter !== 0) {
      stars[i].raw = fullStar
      stars[i].percent = calcStarFullness(stars[i])
      fullStarsCounter--
    }
    else {
      const surplus = Math.round((ratingRecalculated % 1) * 10) / 10
      const roundedOneDecimalPoint = Math.round(surplus * 10) / 10
      stars[i].raw = roundedOneDecimalPoint
      stars[i].percent = calcStarFullness(stars[i])
      return
    }
  }
}
function initStars() {
  for (let i = 0; i < totalStars; i++) {
    stars.push({
      raw: emptyStar,
      percent: `${emptyStar}%`,
    })
  }
  setStars()
}
function getFullFillColor(starData: any) {
  return starData.raw !== emptyStar
    ? props.styleFullStarColor
    : props.styleEmptyStarColor
}
initStars()
</script>

<template>
  <div class="flex items-center" :class="`justify-${position}`">
    <div class="flex flex-col items-center">
      <div class="flex text-success">
        <div v-for="(star, index) in stars" :key="index">
          <svg :fill="`url(#gradient${star.raw}${styleFullStarColor})`" :width="styleStarSize" :height="styleStarSize">
            <polygon :points="getStarPoints" style="fill-rule:nonzero;" />
            <defs>
              <linearGradient :id="`gradient${star.raw}${styleFullStarColor}`">
                <stop id="stop1" :offset="star.percent" stop-opacity="1" :stop-color="getFullFillColor(star)" />
                <stop id="stop2" :offset="star.percent" stop-opacity="0" :stop-color="getFullFillColor(star)" />
                <stop id="stop3" :offset="star.percent" stop-opacity="1" :stop-color="styleEmptyStarColor" />
                <stop id="stop4" offset="100%" stop-opacity="1" :stop-color="styleEmptyStarColor" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
      <div v-if="maxRating" class="text-sm mt-1 text-center text-gray-dark">
        {{ `${rating} ${maxRating}` }}
      </div>
    </div>
    <slot />
  </div>
</template>
